// extracted by mini-css-extract-plugin
export var button = "numberedpanel-module--button--7b18e";
export var card = "numberedpanel-module--card--d9fb9";
export var child = "numberedpanel-module--child--c06b3";
export var copy = "numberedpanel-module--copy--18204";
export var desktop = "numberedpanel-module--desktop--c92c8";
export var image = "numberedpanel-module--image--b0ce8";
export var link = "numberedpanel-module--link--5c24b";
export var mediaWrapper = "numberedpanel-module--mediaWrapper--2609a";
export var mobile = "numberedpanel-module--mobile--93773";
export var numberCircle = "numberedpanel-module--numberCircle--4d738";
export var paragraph = "numberedpanel-module--paragraph--c9be2";
export var playButton = "numberedpanel-module--playButton--45eb2";
export var reactplayer = "numberedpanel-module--reactplayer--fe84e";
export var reactplayerModal = "numberedpanel-module--reactplayerModal--33dbb";
export var title = "numberedpanel-module--title--0e39c";
export var video = "numberedpanel-module--video--77dab";
export var videoWrap = "numberedpanel-module--videoWrap--65f28";
export var vjsIconPlaceholder = "numberedpanel-module--vjs-icon-placeholder--b8186";
export var width90 = "numberedpanel-module--width90--74469";